export default __webpack_public_path__ + "static/media/green-star.fcee2c04.svg";